import { ReactNode, useEffect } from "react"
import { bootstrapElectron } from "@/store/electron-state"

export const ElectronIPC: React.FC<{ children: ReactNode }> = ({ children }) => {
	useEffect(() => bootstrapElectron(), [])
	return <>{children}</>
}
